import React, { useCallback, useEffect, useRef, useState } from 'react';

import {
  convertAmount,
  freeBetStore,
  getAmountWithCurrency,
  useClickOutside,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { BetAmountsBlock } from '../betAmountsBlock';
import { candiesByIndex, TranslationKeys } from '../../../enums';
import { candyDataStore } from '../../../store';
import { gameStore } from '../../../store';

export const GameBetButtons = observer(() => {
  const { activeFreeBet } = freeBetStore;
  const { isBetsClosed } = gameStore;
  const { limits } = gameConfigStore;
  const { balance, currencyCode } = userInfoStore;
  const { candiesBetData, resetCandiesData, setCandiesBetData, resetReBetData, multiplierData } =
    candyDataStore;
  const [isOpen, setIsOpen] = useState(false);
  const [isAddScaleClassName, setIsAddScaleClassName] = useState(false);
  const [currentMultiplierData, setCurrentMultiplierData] = useState(false);
  // const [haveBet, setHaveBet] = useState(false);
  // const [haveFreeBet, setHaveFreeBet] = useState(false);
  const [isChangeOdd, setIsChangeOdd] = useState(false);
  const t = useTranslation();
  const [betAmountBlockRef, hasBatAmountBlockClickOutside] = useClickOutside();
  const ref = useRef();

  const selectedBetsAmount = candiesBetData.filter((candie) => candie.amount);

  useEffect(() => {
    // if (selectedBetsAmount.length && !activeFreeBet.id) {
    //   setHaveBet(true);
    // }
    // if (selectedBetsAmount.length && activeFreeBet.id) {
    //   setHaveFreeBet(true);
    // }
    // if (isBetsClosed) {
    //   setHaveBet(false);
    //   setHaveFreeBet(false);
    // }
  }, [selectedBetsAmount.length, activeFreeBet.id, isBetsClosed]);

  // useEffect(() => {
  //   if ((activeFreeBet.id && haveBet) || (!activeFreeBet.id && haveFreeBet)) {
  //     resetCandiesData();
  //     resetReBetData();
  //   }
  // }, [activeFreeBet.id, haveBet, haveFreeBet]);

  useEffect(() => {
    if (multiplierData) {
      setCurrentMultiplierData(multiplierData);
    }

    setIsAddScaleClassName(true);
  }, [multiplierData]);

  useEffect(() => {
    if (hasBatAmountBlockClickOutside) {
      const updatedCandiesData = candiesBetData.map((item) => {
        return { ...item, isBetBlockOpen: false };
      });
      setCandiesBetData(updatedCandiesData);
      setIsOpen(false);
    }
  }, [hasBatAmountBlockClickOutside]);

  const handleBetClick = useCallback(
    (e, candyData, isReset) => {
      e.stopPropagation();

      if (!isBetsClosed) {
        const updatedCandiesData = candiesBetData.map((item) => {
          if (item.index === candyData.index) {
            if (isReset) {
              return { ...item, amount: null };
            }
            setIsOpen(!item.isBetBlockOpen);
            return { ...item, isBetBlockOpen: !item.isBetBlockOpen };
          }

          return { ...item, isBetBlockOpen: false };
        });
        setCandiesBetData(updatedCandiesData);
      }
    },
    [candiesBetData, setIsOpen, isBetsClosed]
  );

  const handleQuickBet = useCallback(
    ({ quickBet: amount, index }) => {
      const updatedCandiesData = candiesBetData.map((item) => {
        if (item.index === index) {
          return { ...item, amount, isBetBlockOpen: !item.isBetBlockOpen };
        }

        return { ...item };
      });

      // const pendingBetAmount = updatedCandiesData.reduce((acc, curr) => {
      //   if (curr.amount) {
      //     return acc + curr.amount;
      //   }
      //   return acc;
      // }, 0);

      // if (balance < pendingBetAmount && isDemo) {
      //   notificationStore.setNotificationType({ responseCode: BetResponseCode.InsufficientFunds });
      //   resetReBetData();
      //   resetCandiesData();
      // } else {
      setCandiesBetData(updatedCandiesData);
      // }
    },
    [candiesBetData, balance]
  );

  useEffect(() => {
    return () => {
      resetReBetData();
      resetCandiesData();
    };
  }, []);

  useEffect(() => {
    if (multiplierData?.multiplierCandy) {
      setTimeout(() => {
        setIsChangeOdd(true);
      }, 1020);
    } else {
      setIsChangeOdd(true);
    }
    return () => {
      setIsChangeOdd(false);
    };
  }, [multiplierData?.multiplierCandy]);

  return (
    <div className='bet-button-wrapper'>
      <div className='bet-button-holder'>
        {candiesBetData.map((item, index) => {
          return (
            <div
              className={`bet-button-item ${
                (isBetsClosed && item.amount) || isBetsClosed ? 'no-hover' : ''
              }`}
              // !item.amount && isBetsClosed ? 'passive' :
              key={item.index}
              ref={ref}
            >
              {isOpen && item.isBetBlockOpen && (
                <BetAmountsBlock
                  index={item.index}
                  activeFreeBet={activeFreeBet}
                  handleQuickBet={handleQuickBet}
                  amount={item.amount}
                  betAmountBlockRef={betAmountBlockRef}
                  quickBets={limits.quickBets}
                  currencyCode={currencyCode}
                />
              )}
              <div className={`bet-button-item-circle ${item.amount ? 'active' : ''}`}>
                {item.odd && (
                  <p
                    className={`circle-bet-amount ${
                      (multiplierData
                        ? +item.index === +multiplierData.multiplierCandy && isAddScaleClassName
                        : currentMultiplierData &&
                          +item.index === +currentMultiplierData.multiplierCandy) && isChangeOdd
                        ? 'scale-number'
                        : ''
                    }`}
                    onAnimationEnd={() => {
                      setIsAddScaleClassName(false);
                      // setIsChangeOdd(false)
                    }}
                  >
                    <span className='sp-f-shadow'>x</span>
                    <span className='sp-f-shadow'>
                      {multiplierData &&
                      item.index === multiplierData.multiplierCandy &&
                      isChangeOdd
                        ? multiplierData.multiplierOdd
                        : item.odd}
                    </span>
                  </p>
                )}
                <img
                  className={`circle-img${index + 1}`}
                  src={candiesByIndex[item.index]}
                  alt='candy'
                />

                <div className='sm-c-an-big-shadow' />
              </div>
              <div className='bet-button-item-btn'>
                {item.amount && !isBetsClosed && (
                  <div
                    className='bet-button-item-btn-close'
                    onClick={(e) => handleBetClick(e, item, true)}
                  >
                    <i className='bc-i-close' />
                  </div>
                )}
                <button
                  className={`bet-button-item-block ${
                    item.amount || isBetsClosed ? '' : 'pulse-anim'
                  } bet-btn`}
                  onClick={(e) => {
                    handleBetClick(e, item);
                  }}
                >
                  <p className='bet-button-item-block-text'>
                    {item.amount
                      ? `${getAmountWithCurrency({ amount: convertAmount(item.amount) })}`
                      : activeFreeBet.id
                      ? `${t(TranslationKeys.FreeBet)} ${activeFreeBet.remainingCount}`
                      : t(TranslationKeys.Bet)}
                  </p>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});
